<lib-page-layout>
  <lib-title-navbar pageHeader title="Informacje o wersji"></lib-title-navbar>
  <div class="version-page">
    <div class="version-card version-card--current">
      <div class="version-card__label">Aktualna wersja</div>
      <div class="version-card__value">{{ appVersion }}</div>
      <div class="version-card__build">Build: {{ buildVersion }}</div>
    </div>

    <div class="version-card">
      <div class="version-card__label">Najnowsza wersja</div>
      <div class="version-card__value">{{ newestVersion() }}</div>
    </div>

    <div class="versions-section">
      <div class="versions-section__title">Dostępne wersje</div>
      <div class="versions-list">
        @for (v of availableVersions(); track v) {
          <div class="version-tag" [class.version-tag--current]="v === appVersion">
            {{ v }}
            @if (v === appVersion) {
              <span class="current-badge">aktualna</span>
            }
          </div>
        }
      </div>
    </div>
  </div>
</lib-page-layout>
